/**
 * Copyright (c) 2022 TechDivision GmbH
 * All rights reserved
 */

function getProgressBarWidth() {
    const scrollDepth = document.querySelector('body').offsetHeight - window.innerHeight
    const depth = parseFloat((window.pageYOffset / (scrollDepth / 100)) * 0.01)
    return `transform: scaleX(${depth});`
}

export function scrollProgressBar() {
    const scrollElement = document.querySelector('.js-scroll-progress-bar')
    if (scrollElement != null) {
        // initial set
        scrollElement.style.cssText = getProgressBarWidth()
        document.addEventListener('scroll', function () {
            scrollElement.style.cssText = getProgressBarWidth()
        })
    }
}
